import { prop } from '@lib/style/theme';
import { cleanProps } from '@lib/utils';
import { css } from 'styled-components';
import { unitStrict } from '../unit';

export interface MaxAndMinProps {
    maxWidth: number | string;
    minWidth: number | string;
    maxHeight: number | string;
    minHeight: number | string;
}

/**
 * Max Width
 * @param defaultValue
 * @returns {[]|null|*}
 */
export const maxWidth = (defaultValue?: MaxAndMinProps['maxWidth']): any => css`
    & {
        max-width: ${prop('maxWidth', defaultValue, unitStrict)};
    }
`;

maxWidth.clean = (props): any => cleanProps(props, ['maxWidth']);

/**
 * Min Width
 * @param defaultValue
 * @returns {[]|null|*}
 */
export const minWidth = (defaultValue?: MaxAndMinProps['minWidth']): any => css`
    & {
        min-width: ${prop('minWidth', defaultValue, unitStrict)};
    }
`;

minWidth.clean = (props): any => cleanProps(props, ['minWidth']);

/**
 * Max Height
 * @param defaultValue
 * @returns {[]|null|*}
 */
export const maxHeight = (defaultValue?: MaxAndMinProps['maxHeight']): any => css`
    & {
        max-height: ${prop('maxHeight', defaultValue, unitStrict)};
    }
`;

maxHeight.clean = (props): any => cleanProps(props, ['maxHeight']);

/**
 * Min Height
 * @param defaultValue
 * @returns {[]|null|*}
 */
export const minHeight = (defaultValue?: MaxAndMinProps['minHeight']): any => css`
    & {
        min-height: ${prop('minHeight', defaultValue, unitStrict)};
    }
`;

minHeight.clean = (props): any => cleanProps(props, ['minHeight']);
